import React from "react"
import PropTypes from "prop-types"
import { File } from "@bw/bits"
import styled from "styled-components"

const Grid = styled.div`
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
`

const Downloads = ({ files }) => {
  if (!files || files.length === 0) {
    return null
  }

  return (
    <Grid columns={3}>
      {files.map((file, i) => {
        if (!file.fileUrl) {
          return null
        }
        return (
          <div key={i}>
            <File
              title={file.title}
              href={file.fileUrl}
              description={file.description}
            />
          </div>
        )
      })}
    </Grid>
  )
}

Downloads.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      fileUrl: PropTypes.string,
    })
  ),
}

export { Downloads }
